module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-cc-71ed2cbeb5d33fcc294e00f5d6f159f7.svg";